export const getAllQuestions = (user, stageId) => {
    return async (dispatch) => {
        try {
            dispatch({ type: 'GET_ALL_QUESTIONS' });

            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}microcredenciales/solicitudes/preguntas?idEtapa=${stageId}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + user.token
                },
            });
            const requestData = await response.json();

            dispatch({
                type: 'GET_ALL_QUESTIONS_SUCCESS',
                payload: requestData,
            });
        } catch (error) {
            dispatch({
                type: 'GET_ALL_QUESTIONS_ERROR',
                payload: error.message,
            });
        }
    };
};

export const getAllPlanes = (user, careerId) => {
    return async (dispatch) => {
        try {
            dispatch({ type: 'GET_ALL_CAREER_PLANS' });

            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}microcredenciales/carreras/planes?carreraId=${careerId}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + user.token
                },
            });
            const requestData = await response.json();

            dispatch({
                type: 'GET_ALL_CAREER_PLANS_SUCCESS',
                payload: requestData,
            });
        } catch (error) {
            dispatch({
                type: 'GET_ALL_CAREER_PLANS_ERROR',
                payload: error.message,
            });
        }
    };
};

export const getAllAnswers = (user, proposalId) => {
    return async (dispatch) => {
        try {
            dispatch({ type: 'GET_ALL_ANSWERS' });

            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}microcredenciales/respuestas/${proposalId}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + user.token
                },
            });
            const answersData = await response.json();
            

            dispatch({
                type: 'GET_ALL_ANSWERS_SUCCESS',
                
                payload: answersData
            });
        } catch (error) {
            dispatch({
                type: 'GET_ALL_ANSWERS_ERROR',
                payload: error.message,
            });
        }
    };
};

export const getAllUserAnswers = (user,userId, proposalId) => {
    return async (dispatch) => {
        try {
            dispatch({ type: 'GET_ALL_USER_ANSWERS' });

            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}microcredenciales/respuestas/${proposalId}/${userId}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + user.token
                },
            });
            const answersData = await response.json();
            dispatch({
                type: 'GET_ALL_USER_ANSWERS_SUCCESS',
                payload: answersData,
            });
           
        } catch (error) {
            dispatch({
                type: 'GET_ALL_USER_ANSWERS_ERROR',
                payload: error.message,
            });
        }
    };
};

export const getAllUserAnswersArchivo = (user, userId, proposalId) => {
    return async (dispatch) => {
        try {
            dispatch({ type: 'GET_ALL_USER_ANSWERS_ARCHIVO' });

            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}microcredenciales/respuestas/${proposalId}/${userId}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + user.token
                },
            });
            const answersData = await response.json();
            dispatch({
                type: 'GET_ALL_USER_ANSWERS_ARCHIVO_SUCCESS',
                payload: answersData,
            });
        } catch (error) {
            dispatch({
                type: 'GET_ALL_USER_ANSWERS_ARCHIVO_ERROR',
                payload: error.message,
            });
        }
    };
};

export const getFileAnswer = (fileId,fileName, user) => async (dispatch) => {
    try {
      dispatch({ type: 'GET_FILE_ANSWER' });
        
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}microcredenciales/respuestas/${fileId}/getFile/${fileName}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + user.token
        },
      });
      
      
      if (response.ok) {
        const blob = await response.blob();
        dispatch({ type: 'GET_FILE_ANSWER_SUCCESS' });
         
          const downloadUrl = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = downloadUrl;
          a.download = fileName;
          document.body.appendChild(a);
          a.click();
          a.remove();
          window.URL.revokeObjectURL(downloadUrl);
      } else {
        const errorData = await response.statusText;
        dispatch({ type: 'GET_FILE_ANSWER_FAIL', payload: errorData });
      }
  
    }
    catch (error){
      dispatch({ type: 'GET_FILE_ANSWER_ERROR', payload: error.message });
    }
  };

export const getAllJuryAnswers = (user, proposalId) => {
    return async (dispatch) => {
        try {
            dispatch({ type: 'GET_ALL_JURY_ANSWERS' });

            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}microcredenciales/respuestas/evaluadores/${proposalId}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + user.token
                },
            });
            const answersData = await response.json();
            dispatch({
                type: 'GET_ALL_JURY_ANSWERS_SUCCESS',
                payload: answersData,
            });
           
        } catch (error) {
            dispatch({
                type: 'GET_ALL_JURY_ANSWERS_ERROR',
                payload: error.message,
            });
        }
    };
};


export const setAnswer = (questionId, answer, observacion, answerId) => ({
    type: 'SET_ANSWER',
    payload: { questionId, answer, observacion, answerId },
});

export const setAnswerMultiple = (grandQuestionIdM,grandQuestionAnswer, questionIdM, answerM, observacionM ) => ({
    type: 'SET_ANSWER_MULTIPLE',
    payload: { grandQuestionIdM, grandQuestionAnswer,questionIdM, answerM, observacionM },
  });

export const saveAnswer = (answerData, user, file) => async (dispatch) => {
    try {
        dispatch({ type: 'SAVE_ANSWER' });
        const formData = new FormData();
        
        // Asegurarnos de que el ID de la respuesta se incluya en el objeto
        if (!answerData.Id && answerData.answerId) {
            answerData.Id = answerData.answerId;
        }


        Object.keys(answerData).forEach((key) => {
            formData.append(key, answerData[key]);
        });
        
        formData.append('file', file);
        formData.append('model', JSON.stringify(answerData));
        
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}microcredenciales/respuestas/save`, {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + user.token
            },
            body: formData
        });

        if (response.ok) {           
            dispatch({ type: 'SAVE_ANSWER_SUCCESS', payload: answerData });
        } else {
            const errorData = await response.statusText;           
            dispatch({ type: 'SAVE_ANSWER_FAIL', payload: errorData });
        }
        
    } catch (error) {
        dispatch({ type: 'SAVE_ANSWER_ERROR', payload: error.message });
    }
};

export const deleteAnswer = (idAnswer, user) => async (dispatch) => {
    try {
        dispatch({ type: 'DELETE_ANSWER' });
        
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}microcredenciales/respuestas/${idAnswer}`, {
          method: 'DELETE',
          headers: {
            'Authorization': 'Bearer ' + user.token
          },
          //body: formData
        });

        if (response.ok) {           
            dispatch({ type: 'DELETE_ANSWER_SUCCESS', payload: idAnswer });
        
        } else {
            const errorData = await response.statusText;           
            dispatch({ type: 'DELETE_ANSWER_FAIL', payload: errorData });
        }
        
    } catch (error) {
        dispatch({ type: 'DELETE_ANSWER_ERROR', payload: error.message });
    }
};